var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhancedHardware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 88.373 78.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16853",
    "data-name": "Group 16853",
    transform: "translate(-711.904 -4577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32475",
    "data-name": "Path 32475",
    d: "M34.253,2A19.253,19.253,0,1,0,53.506,21.253,19.253,19.253,0,0,0,34.253,2Z",
    transform: "translate(696.904 4575)",
    fill: "#ffd2d2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_9",
    transform: "translate(724.475 4580)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32556",
    "data-name": "Path 32556",
    d: "M73.167,41.537H4.636A2.635,2.635,0,0,1,2,38.9V4.636A2.635,2.635,0,0,1,4.636,2H73.167A2.635,2.635,0,0,1,75.8,4.636V38.9A2.635,2.635,0,0,1,73.167,41.537Zm-65.9-5.272H70.531V7.272H7.272Z",
    transform: "translate(0 0)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32557",
    "data-name": "Path 32557",
    d: "M17.636,29.179A2.635,2.635,0,0,1,15,26.543V18.636a2.636,2.636,0,0,1,5.272,0v7.907A2.635,2.635,0,0,1,17.636,29.179Z",
    transform: "translate(21.266 22.901)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32558",
    "data-name": "Path 32558",
    d: "M30.451,24.272H14.636a2.636,2.636,0,0,1,0-5.272H30.451a2.636,2.636,0,0,1,0,5.272Z",
    transform: "translate(16.358 27.809)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32559",
    "data-name": "Path 32559",
    d: "M73.167,43.087H4.636A2.635,2.635,0,0,1,2,40.451V24.636A2.635,2.635,0,0,1,4.636,22H73.167A2.635,2.635,0,0,1,75.8,24.636V40.451A2.635,2.635,0,0,1,73.167,43.087Zm-65.9-5.272H70.531V27.272H7.272Z",
    transform: "translate(0 32.716)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32560",
    "data-name": "Path 32560",
    d: "M36.63,30.272H7.636a2.636,2.636,0,1,1,0-5.272H36.63a2.636,2.636,0,0,1,0,5.272Z",
    transform: "translate(4.907 37.624)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32561",
    "data-name": "Path 32561",
    d: "M27.674,30.272A2.636,2.636,0,0,1,27.646,25h.028a2.636,2.636,0,0,1,0,5.272Z",
    transform: "translate(37.665 37.624)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32562",
    "data-name": "Path 32562",
    d: "M24.674,30.272A2.636,2.636,0,0,1,24.646,25h.028a2.636,2.636,0,0,1,0,5.272Z",
    transform: "translate(32.758 37.624)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32563",
    "data-name": "Path 32563",
    d: "M21.674,30.272A2.636,2.636,0,0,1,21.646,25h.028a2.636,2.636,0,0,1,0,5.272Z",
    transform: "translate(27.85 37.624)",
    fill: "#2a3d57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhancedHardware);
export default __webpack_public_path__ + "static/media/EnhancedHardware.5f7d860aad8d618782a802eda2ade4f2.svg";
export { ForwardRef as ReactComponent };